<div
  class="type-group"
>
  <h2>
    Point-Based Tiles
  </h2>

  <div
    class="tile-types"
  >
    <div
      class="tile-type alt-color"
      [attr.data-color]="'indigo-white'"
      (click)="showPointBasedTilesInfo()"
    >
      <div
        class="middle-content"
      >
        <i class="fa-regular fa-toggle-on"></i>
      </div>

      <div
        class="bottom-content"
      >
        Toggle
      </div>
    </div>
    <div
      class="tile-type alt-color"
      [attr.data-color]="'indigo-white'"
      (click)="showFormulaTileCreation? createNumericTile() : showPointBasedTilesInfo()"
    >
      <div
        class="middle-content"
      >
        <i class="fa-regular fa-1"></i><i class="fa-regular fa-2"></i><i class="fa-regular fa-3"></i>
      </div>

      <div
        class="bottom-content"
      >
        Numeric
      </div>
    </div>

    <div
      class="tile-type alt-color"
      [attr.data-color]="'indigo-white'"
      (click)="showPointBasedTilesInfo()"
    >
      <div
        class="middle-content"
      >
        <i class="fa-regular fa-list-radio"></i>
      </div>

      <div
        class="bottom-content"
      >
        Multi-Choice
      </div>
    </div>
  </div>
</div>

<div
  class="type-group"
>
  <h2>
    SuperTiles&trade;
  </h2>

  <div
    class="tile-types"
  >
    <div
      class="tile-type alt-color"
      [attr.data-color]="'indigo-white'"
      (click)="createTileFolder()"
    >
      <div
        class="middle-content"
      >
        @if (creatingTileFolder) {
          <motn-spinner></motn-spinner>
        } @else {
          <motn-fa-icon [icon]="'fa-regular fa-folder-grid'"></motn-fa-icon>
        }
      </div>

      <div
        class="bottom-content"
      >
        Folder
      </div>
    </div>

    @if (showCanvasTileCreation) {
      <div
        class="tile-type alt-color"
        [attr.data-color]="'indigo-white'"
        (click)="createCanvasTile()"
      >
        <div
          class="middle-content"
        >
          @if (creatingCanvasTile) {
            <motn-spinner></motn-spinner>
          } @else {
            <motn-fa-icon [icon]="'fa-regular fa-image'"></motn-fa-icon>
          }
        </div>

        <div
          class="bottom-content"
        >
          Canvas
        </div>
      </div>
    }
  </div>
</div>

@if (showBulkCreation) {
  <div
    class="type-group"
  >
    <h2>
      Bulk Creation
    </h2>

    <div
      class="tile-types"
    >
      <div
        class="tile-type alt-color"
        [attr.data-color]="'indigo-white'"
        (click)="openBulkCreationModal()"
      >
        <div
          class="middle-content"
        >
          <i class="fa-regular fa-file-csv"></i>
        </div>

        <div
          class="bottom-content"
        >
          Bulk Create
        </div>
      </div>
    </div>
  </div>
}

@if (creatingFormulaTile) {
  <motn-numeric-tile-creator
    (closed$)="creatingFormulaTile = false"
    (created$)="editingTile = $event; creatingFormulaTile = false"
  ></motn-numeric-tile-creator>
}

@if (editingTile) {
  <motn-tile-editor
    [tileId]="editingTile"
    (closed$)="closeTileEditor()"
    (deleted$)="closeTileEditor()"
  ></motn-tile-editor>
}
